import angular from 'angular';

import pageComponent from './page.component';

import search from './search/search';
import verify from './verify/verify';
import original from './original/original';
import author from './author/author';
import announcement from './announcement/announcement';
import terms from './terms/terms';
import career from './career/career';
import evidence from './evidence/evidence';
import help from './help/help';
import userInfoService from './user-info.service';
import payment from './payment/payment';
import similarity from './similarity/similarity'

let childModules = [
    search,
    verify,
    original,
    author,
    announcement,
    terms,
    career,
    evidence,
    help,
    payment,
    similarity
];

let states = [
    {
        name: 'page',
        abstract: true,
        component: 'page', 
        'resolve': {
            appUser: (userLogin) => {
                "ngInject";

                return userLogin.getUserOrPromise();
            }
        }
    }
];

let childModuleNames = [];

childModules.forEach((m) => {
    childModuleNames.push(m.name);

    m.states.forEach((s) => {

        s.name = 'page.' + s.name;

        states.push(s);
    });
});

let pageModule = angular.module('page', childModuleNames)
    .component('page', pageComponent)
    .service('userInfo', userInfoService)
    .name;
export default {name: pageModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/page.js